module.exports = new __parcel__URL__("Data.c79f939a.jpg").toString();